import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
    NbActionsModule,
    NbLayoutModule,
    NbMenuModule,
    NbSearchModule,
    NbSidebarModule,
    NbUserModule,
    NbContextMenuModule,
    NbButtonModule,
    NbSelectModule,
    NbIconModule,
    NbThemeModule,
    NbCardModule,
    NbWindowModule,
    NbProgressBarModule,
    NbTooltipModule,
    NbToastrModule,
    NbListModule,
    NbDatepickerModule,
    NbInputModule,
    NbToggleModule,
    NbCalendarKitModule,
    NbTimepickerModule,
    NbSpinnerModule,
    NbCheckboxModule,
    NbRadioModule,
    NbDialogModule,
    NbAlertModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbFormFieldModule,
    NbPopoverModule,
    NbAccordionModule,
    NbAutocompleteModule,
    NbTagModule,
    NbStepperModule,
    NbBadgeModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';

import {
    HeaderComponent,
    LayoutDirectionSwitcherComponent,
    SearchInputComponent,
    SwitcherComponent,
    PaginationComponent,
    NewsCardComponent,
    SharedTournamentSituationFilterComponent,
    SharedTournamentYearFilterComponent,
    SharedRankingListComponent,
    SharedDetailNewsComponent,
    SharedRankingClassifComponent,
    SharedFilterComponent,
    SharedTrainedListComponent,
    SharedRankingHistoryComponent,
    SharedSidebarService,
    SharedLatestNewsService,
    SharedFeaturedService,
    SharedAttachmentsService,
    SharedTournamentEnrollComponent,
    SharedSidebarComponent,
    SharedOverviewComponent,
    SharedFeaturedComponent,
    SharedAttachmentsComponent,
    SharedAttachmentsDetailComponent,
    SharedLatestNewsComponent,
    SharedLatestVideos,
    SharedLatestVideosService,
    WtnComponent,
    SharedPartnerComponent,
    SharedBestMovementComponent,
    SharedMatchProgramComponent,
    DialogConfirmActionComponent,
    SharedH2hComponent,
    AutocompleteComponent,
    SharedPromptConfirmation,
    PartnersComponent,
    CardFeaturedComponent,
    CardRankingComponent,
    DevToolbarComponent,
    WtnCtaComponent,
    WtnRegisterCtaComponent,
    NewsCardGnuComponent,
    EventsCardComponent,
    CallToActionComponent,
    WtnPointComponent,
    RedirectTokenComponent,
    TournamentCardComponent,
    Filter,
    MatchCardComponent,
    ImageUploaderComponent,
    NoResultsComponent,
    TokenRequestComponent,
    TokenValidateComponent,
    ConfirmationDialogComponent,
    FullScreenLoaderComponent,
} from './components';
import { CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe, DateFormatPipe } from './pipes';

import { DEFAULT_THEME } from './styles/theme.default';

import { BackButtonComponent } from './components/back-button/back-button.component';

import { RouterModule } from '@angular/router';

import { NbDateFnsDateModule } from '@nebular/date-fns';
import { ptBR } from 'date-fns/locale';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BoxComponent } from './components/box/box.component';
import { PermissionFormComponent } from './components/permission-form/permission-form.component';
import { MyDirectivesModule } from './directives/directivesss.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxMaskModule } from 'ngx-mask';
import { NgxGlideModule } from 'ngx-glide';
import { NgxPaginationModule } from 'ngx-pagination';
import { UserService } from '../modules/user/user.service';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { mapLanguageStr } from '@shared/utils/mapLanguageStr';
import { HttpLoaderFactory } from '@core/services/loader-factory.service';

/**
 * Módulos de bibliotecas internas (do próprio angular) e externas
 */
const NG_MODULES = [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxGlideModule,
    TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
        },
    }),
    NgbModule,
    FontAwesomeModule,
    NgxMaskModule.forRoot(),
    NgxPaginationModule,
    RecaptchaModule,
    RecaptchaFormsModule,
];

/**
 * Modulos do nebular
 */
const NB_MODULES = [
    NbLayoutModule,
    NbMenuModule.forRoot(),
    NbUserModule,
    NbActionsModule,
    NbSearchModule,
    NbSidebarModule.forRoot(),
    NbContextMenuModule,
    NbButtonModule,
    NbSelectModule,
    NbIconModule,
    NbEvaIconsModule,
    NbCardModule,
    NbProgressBarModule,
    NbTooltipModule,
    NbTagModule,
    NbToggleModule,
    NbListModule,
    NbCalendarKitModule,
    NbInputModule,
    NbSpinnerModule,
    NbContextMenuModule,
    NbRadioModule,
    NbAlertModule,
    NbCheckboxModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbPopoverModule,
    NbFormFieldModule,
    NbAccordionModule,
    NbAutocompleteModule,
    NbWindowModule.forChild(),
    NbToastrModule.forRoot(),
    NbDialogModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbDateFnsDateModule.forRoot({
        format: 'dd/MM/yyyy',
        parseOptions: { locale: ptBR },
    }),
    NbStepperModule,
    NbBadgeModule,
];

/**
 * Serviços locais
 */
const SERVICES = [
    SharedSidebarService,
    SharedLatestNewsService,
    SharedFeaturedService,
    SharedAttachmentsService,
    SharedLatestVideosService,
    UserService,
];

/**
 * Componentes locais
 */
const COMPONENTS = [
    SwitcherComponent,
    LayoutDirectionSwitcherComponent,
    HeaderComponent,
    SearchInputComponent,
    BackButtonComponent,
    BoxComponent,
    PermissionFormComponent,
    PaginationComponent,
    NewsCardComponent,
    SharedTournamentSituationFilterComponent,
    SharedTournamentYearFilterComponent,
    SharedRankingListComponent,
    SharedDetailNewsComponent,
    SharedRankingClassifComponent,
    SharedFilterComponent,
    SharedTrainedListComponent,
    SharedRankingHistoryComponent,
    SharedTournamentEnrollComponent,
    SharedSidebarComponent,
    SharedOverviewComponent,
    SharedFeaturedComponent,
    SharedAttachmentsComponent,
    SharedAttachmentsDetailComponent,
    SharedLatestNewsComponent,
    SharedLatestVideos,
    SharedPartnerComponent,
    SharedBestMovementComponent,
    SharedMatchProgramComponent,
    SharedH2hComponent,
    SharedPromptConfirmation,
    DialogConfirmActionComponent,
    WtnComponent,
    WtnCtaComponent,
    WtnRegisterCtaComponent,
    AutocompleteComponent,
    PartnersComponent,
    CardFeaturedComponent,
    CardRankingComponent,
    DevToolbarComponent,
    NewsCardGnuComponent,
    EventsCardComponent,
    CallToActionComponent,
    WtnPointComponent,
    RedirectTokenComponent,
    TournamentCardComponent,
    Filter,
    MatchCardComponent,
    ImageUploaderComponent,
    NoResultsComponent,
    TokenRequestComponent,
    TokenValidateComponent,
    ConfirmationDialogComponent,
    FullScreenLoaderComponent,
];

/**
 * Pipes
 */
const PIPES = [CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe, DateFormatPipe];

@NgModule({
    declarations: [...COMPONENTS, ...PIPES],
    imports: [CommonModule, ...NG_MODULES, ...NB_MODULES, MyDirectivesModule],
    exports: [CommonModule, ...PIPES, ...COMPONENTS, NB_MODULES, NG_MODULES, MyDirectivesModule],
})
export class ThemeModule {
    static forRoot(): ModuleWithProviders<ThemeModule> {
        return {
            ngModule: ThemeModule,
            providers: [
                ...NbThemeModule.forRoot(
                    {
                        name: 'default',
                    },
                    [DEFAULT_THEME]
                ).providers,
                ...SERVICES,
                {
                    provide: RECAPTCHA_LANGUAGE,
                    useFactory: () => {
                        const selectedLanguage = JSON.parse(localStorage.getItem('tnt.userLangs')).selected;
                        return mapLanguageStr(selectedLanguage);
                    },
                },
            ],
        };
    }
}
